const VideosComponent = require('../components/VideosComponent.vue').default;

const videos = [
    { path: '/:lang/videos', component: VideosComponent },
    { path: '/:lang/videos/:category', component: VideosComponent, name: 'videos' }
];

export default videos;
